import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import { dateFormatted, getTimeAMPM } from "modules/functions";
import { AWS_PROFILE_IMAGES_URL } from "constants";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import dollarIcon from "assets/img/icons/dollar-icon.svg";
import giftIcon from "assets/img/icons/icons8-gift.svg";
import streakIcon from "assets/img/icons/flash-icon-indigo.svg";
import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";

const RewardHistory = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;
  min-height: 256px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const RewardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const RewardWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const DateTitle = styled.div``;

const RewardBox = styled.div`
  padding: ${css.BOX_PADDING_TERTIARY};
  width: 100%;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
  }
`;

const OverviewColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  flex: 0.5;
`;

const DataRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DataIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const DataValue = styled.div`
  font-weight: ${(props) => (props.bold ? "500" : "300")};
`;

const WinnersColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  flex: 0.5;
`;

const WinnerBox = styled.div`
  padding: 7px 12px;
  width: 100%;
  box-sizing: border-box;

  background: #3c556c;
  border-radius: 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const User = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ProfileImage = styled.div`
  width: 22px;
  min-width: 22px;
  height: 22px;

  border-radius: 50%;
  overflow: hidden;
`;

const Username = styled.div`
  font-size: 14px;
`;

const RewardAmountWrap = styled.div`
  min-width: 85px;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const RewardAmountIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const RewardAmount = styled.div`
  font-size: 14px;
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};
`;

export default ({ data, page, limit, paginate }) => {
  const { rewards, numOfResults } = data.telegramRewardHistory;

  const list = rewards.map((reward) => {
    const winnerList = reward.claims.map((claim) => {
      return (
        <WinnerBox>
          <User>
            <ProfileImage>
              <img
                src={AWS_PROFILE_IMAGES_URL + claim.profile_image}
                width="100%"
              />
            </ProfileImage>
            <Username>{claim.username}</Username>
          </User>
          <RewardAmountWrap>
            <RewardAmountIcon>
              <img src={dollarIcon} width="100%" />
            </RewardAmountIcon>
            <RewardAmount>{reward.reward.toFixed(2)} USD</RewardAmount>
          </RewardAmountWrap>
        </WinnerBox>
      );
    });

    return (
      <RewardWrap>
        <DateTitle>
          {getTimeAMPM(new Date(reward.posted_at))},{" "}
          {dateFormatted(new Date(reward.posted_at), false)}
        </DateTitle>
        <RewardBox>
          <OverviewColumn>
            <DataRow>
              <DataIcon>
                <img src={dollarIcon} width="100%" />
              </DataIcon>
              <DataValue bold={1}>
                {reward.reward.toFixed(2)} USD Reward
              </DataValue>
            </DataRow>
            <DataRow>
              <DataIcon>
                <img src={giftIcon} width="100%" />
              </DataIcon>
              <DataValue>Rewards: {reward.number_of_rewards}x</DataValue>
            </DataRow>
            <DataRow>
              <DataIcon>
                <img src={streakIcon} width="100%" />
              </DataIcon>
              <DataValue>
                Streak Requirement: {reward.streak_requirement}
              </DataValue>
            </DataRow>
          </OverviewColumn>
          <WinnersColumn>{winnerList}</WinnersColumn>
        </RewardBox>
      </RewardWrap>
    );
  });

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <RewardHistory>
      <RewardList>{list}</RewardList>
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
    </RewardHistory>
  );
};
